import { createContext } from 'react';
const AppContext = createContext({
    meta: {},
    setMeta: () => {},
});
export default AppContext;
